import { render } from "./OrderTimePanel.vue?vue&type=template&id=2b348fec&scoped=true"
import script from "./OrderTimePanel.vue?vue&type=script&lang=js"
export * from "./OrderTimePanel.vue?vue&type=script&lang=js"

import "./OrderTimePanel.vue?vue&type=style&index=0&id=2b348fec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b348fec"]])

export default __exports__